import React from 'react';
import {
  Card,
  CardHeader,
  CardBody
} from "@heroui/react";
import UserProfile from '@/components/common/UserProfile';
import EmailProtectionButton from '@/components/common/Buttons/EmailProtectionButton';

interface OwnerCardProps {
  user: {
    nickname?: string;
    email_public?: string;
    first_name?: string;
    last_name?: string;
    avatar?: string;
    [key: string]: any;
  };
  title?: string;
  className?: string;
}

/**
 * OwnerCard - A reusable component for displaying owner information with contact options
 */
export default function OwnerCard({
  user,
  title = "Właściciel książki",
  className = ""
}: OwnerCardProps) {
  // Defensive check - return null if user is undefined or null
  if (!user) return null;

  // Ensure email_public is defined
  const safeUser = {
    ...user,
    email_public: user.email_public || null
  };

  return (
    <Card className={`shadow-sm border border-gray-200 ${className} transition-all duration-300`} data-owner-card>
      <CardHeader className="pb-0 px-6">
        <h3 className="text-lg font-medium text-gray-900">{title}</h3>
      </CardHeader>
      <CardBody className="p-6">
        <div className="flex items-center justify-between">
          <div>
            <UserProfile hasLink={true} obj={safeUser} />
          </div>
          <div data-email-button>
            <EmailProtectionButton
              email={safeUser.email_public}
              buttonText="Napisz"
              ownerName={safeUser.nickname || "właściciela"}
              buttonSize="sm"
              buttonColor="primary"
            />
          </div>
        </div>
      </CardBody>
    </Card>
  );
}